import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import upsertAxpoSiteNameMapping, {
  UpsertAxpoSiteNameMappingRequest,
} from "../http/upsertAxpoSiteNameMapping";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useUpsertAxpoSiteNameMapping = () => {
  const queryClient = useQueryClient();
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useMutation(
    async (body: UpsertAxpoSiteNameMappingRequest) =>
      upsertAxpoSiteNameMapping(
        await getAuthTokenBlocking(getToken, relogin),
        body
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["axpo-site-name-mappings"]);
      },
    }
  );
};

export default useUpsertAxpoSiteNameMapping;
